import { Reducer } from "redux";
import { META_DATA_FAIL, META_DATA_REQUEST, META_DATA_SUCCESS } from "../constants/metaConstants";


interface metaDataState {
  data: {}
}
const initialState : metaDataState = {
    data: {}
}

const metaDataReducer: Reducer<metaDataState> = (state = initialState, action)=>{

    switch(action.type){
        case META_DATA_REQUEST:
            return {data: initialState}
        case META_DATA_SUCCESS:
            return {data: action.payload}
        
        case META_DATA_FAIL:
            return{
                data: initialState,
            }
        default:
        return state
    }

}

export default metaDataReducer